import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useSummaryCardStyles = makeStyles({
    root: {
        ...shorthands.borderRadius('16px'),
        backgroundColor: tokens.colorNeutralBackground4
    },
    contentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalL,
        ...shorthands.padding(tokens.spacingHorizontalXL)
    }
});

export const useSummaryCardSectionStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalM
    },
    lineItem: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    feeDisclaimer: {
        color: tokens.colorNeutralForeground3,
        marginTop: tokens.spacingVerticalXS,
        marginBottom: tokens.spacingVerticalXS
    }
});

export default useSummaryCardStyles;
